module.exports = __webpack_public_path__ + "media/dashboard/assets/images/snooze-1d9fc25bac249fa2051da323c651c70c.svg";